import { render, staticRenderFns } from "./taskData.vue?vue&type=template&id=05d9873a&"
import script from "./taskData.vue?vue&type=script&lang=js&"
export * from "./taskData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports